import { useState } from "react";
import { Button } from "../../ds/DS";
import type { PageProps } from "../Portal";
import { PageHead, ProjectCard } from "./parts";
import { ProjectCreateDialog, ProjectEditDialog } from "./EditDialogs";

export function ProjectsPage(props: PageProps) {
  const { isAdmin, client, projects, reload, toast } = props;
  const [creating, setCreating] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const editing = editId ? projects.find((p) => p.id === editId) : undefined;
  return (
    <div className="stack-24">
      <PageHead
        eyebrow="PROJECTS"
        title="Projects"
        sub={
          isAdmin
            ? `Every piece of work for ${client?.name ?? "this client"}. Hours, health and what's next.`
            : "Every piece of work we have with you, and where each one is."
        }
        actions={
          isAdmin ? (
            <Button icon="plus" onClick={() => setCreating(true)}>
              New project
            </Button>
          ) : undefined
        }
      />
      {projects.length === 0 ? (
        <div className="list-card">
          <div className="list-empty">No projects yet.</div>
        </div>
      ) : (
        <div className="proj-grid">
          {projects.map((p) => (
            <ProjectCard key={p.id} p={p} full ctx={props} onEdit={() => setEditId(p.id)} />
          ))}
        </div>
      )}

      {client ? (
        <ProjectCreateDialog
          open={creating}
          clientId={client.id}
          onClose={() => setCreating(false)}
          onSaved={() => {
            reload();
            toast("Project created.");
          }}
        />
      ) : null}
      {editing ? (
        <ProjectEditDialog
          open
          project={editing}
          onClose={() => setEditId(null)}
          onSaved={() => {
            reload();
            toast("Project updated.");
          }}
        />
      ) : null}
    </div>
  );
}
